import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import styles from './Divider.scss';

const Divider = ({ className, gray, light, primary, secondary, thick }) => {
  const classes = cn({
    'bg-primary': primary,
    'bg-secondary': secondary,
    'bg-gray': gray,
    'bg-light': light,
    [styles.thick]: thick,
    [className]: className
  });

  return (<hr className={classes} />);
};

Divider.propTypes = {
  className: PropTypes.string,
  gray: PropTypes.bool,
  light: PropTypes.bool,
  primary: PropTypes.bool,
  secondary: PropTypes.bool,
  thick: PropTypes.bool
};

Divider.defaultProps = {
  className: '',
  gray: false,
  light: false,
  primary: false,
  secondary: false,
  thick: false
};

export default Divider;
